import { render } from "./DisplayTabIcon.vue?vue&type=template&id=5634fc82"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__